import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "validatorDivision";

const validatorDivisionUrl = "/api/machines/ValidatorDivision";

export const validatorDivisionLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Validator Division",
    url: validatorDivisionUrl,
  }
);
